var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebcam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 39,
    viewBox: "0 0 58 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.261 36.4345C42.2759 36.3596 42.2834 36.2847 42.2834 36.2061C42.2834 36.1294 42.2759 36.0526 42.261 35.9777V28.0088H15.9318V35.9983C15.9187 36.0657 15.9131 36.135 15.9131 36.2061C15.9131 36.2754 15.9187 36.3446 15.9318 36.4139V36.6984H16.0198C16.3979 37.5633 17.7514 38.2035 19.3612 38.2035H38.8371C40.4489 38.2035 41.8005 37.5633 42.1786 36.6984H42.261V36.4345Z",
    fill: "#221F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4248 34.1613C40.4379 34.0977 40.4436 34.0322 40.4436 33.9648C40.4436 33.8993 40.4361 33.8337 40.4248 33.7682V26.9131H17.7722V33.7869C17.761 33.845 17.7554 33.9049 17.7554 33.9648C17.7554 34.0247 17.761 34.0846 17.7722 34.1426V34.3878H17.8471C18.1728 35.131 19.3372 35.6814 20.7224 35.6814H37.4784C38.8636 35.6814 40.028 35.131 40.3537 34.3878H40.4248V34.1613Z",
    fill: "url(#paint0_linear_2_29293)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7729 13.9551V25.8177V26.9147V28.0098H22.9246V26.9147H35.2739V28.0098H40.4256V26.9147V25.8177V13.9551H17.7729Z",
    fill: "url(#paint1_linear_2_29293)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M57.6564 11.5051C57.6564 5.49234 53.3116 0.555974 47.7706 0.0449276V0H10.8368C4.85212 0 0 5.15164 0 11.5051C0 17.8585 4.85212 23.0102 10.8368 23.0102C11.1569 23.0102 11.4751 22.9952 11.7896 22.9671H45.8687C46.1831 22.9952 46.4995 23.0102 46.8215 23.0102C47.1416 23.0102 47.4598 22.9952 47.7743 22.9671C53.3116 22.4542 57.6564 17.5178 57.6564 11.5051Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4393 11.6771C56.4393 6.26523 52.2873 1.82306 46.9952 1.36256V1.32324H11.7069C5.98801 1.32324 1.35303 5.95822 1.35303 11.6771C1.35303 17.3959 5.98801 22.0309 11.7069 22.0309C12.0139 22.0309 12.3171 22.0178 12.6166 21.9916H45.1757C45.4752 22.0178 45.7785 22.0309 46.0855 22.0309C46.3925 22.0309 46.6957 22.0178 46.9952 21.9916C52.2873 21.5311 56.4393 17.0889 56.4393 11.6771Z",
    fill: "url(#paint2_linear_2_29293)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 17.0958C21.343 13.9611 21.343 8.87874 18.2083 5.74404C15.0736 2.60933 9.99125 2.60933 6.85654 5.74404C3.72184 8.87874 3.72184 13.9611 6.85654 17.0958C9.99125 20.2305 15.0736 20.2305 18.2083 17.0958Z",
    fill: "#12100B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4683 19.1523C16.6916 19.1523 20.1152 15.7286 20.1152 11.5053C20.1152 7.28205 16.6916 3.8584 12.4683 3.8584C8.24495 3.8584 4.82129 7.28205 4.82129 11.5053C4.82129 15.7286 8.24495 19.1523 12.4683 19.1523Z",
    fill: "url(#paint3_linear_2_29293)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4669 16.0393C15.0278 16.0393 17.1038 13.9633 17.1038 11.4025C17.1038 8.84161 15.0278 6.76562 12.4669 6.76562C9.90607 6.76562 7.83008 8.84161 7.83008 11.4025C7.83008 13.9633 9.90607 16.0393 12.4669 16.0393Z",
    fill: "#1D1916"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2523 11.67C15.4929 10.1872 14.4859 8.79003 13.0031 8.54938C11.5203 8.30873 10.1232 9.3157 9.88251 10.7985C9.64186 12.2813 10.6488 13.6785 12.1316 13.9191C13.6145 14.1598 15.0116 13.1528 15.2523 11.67Z",
    fill: "#12100B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.3809 12.7766C12.3809 13.1585 12.072 13.4692 11.6882 13.4692C11.3064 13.4692 10.9956 13.1604 10.9956 12.7766C10.9956 12.3947 11.3045 12.084 11.6882 12.084C12.0701 12.084 12.3809 12.3947 12.3809 12.7766Z",
    fill: "#FEF7FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1238 9.51183C22.1238 9.64661 22.0133 9.75705 21.8785 9.75705C21.7437 9.75705 21.6333 9.64661 21.6333 9.51183C21.6333 9.37705 21.7437 9.2666 21.8785 9.2666C22.0133 9.2666 22.1238 9.37705 22.1238 9.51183Z",
    fill: "#12100B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1238 12.9581C22.1238 13.0929 22.0133 13.2033 21.8785 13.2033C21.7437 13.2033 21.6333 13.0929 21.6333 12.9581C21.6333 12.8233 21.7437 12.7129 21.8785 12.7129C22.0133 12.7129 22.1238 12.8215 22.1238 12.9581Z",
    fill: "#12100B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5663 10.3052C22.5457 10.44 22.4203 10.5317 22.2874 10.5112C22.1526 10.4906 22.0609 10.3651 22.0815 10.2322C22.1021 10.0975 22.2275 10.0057 22.3604 10.0263C22.4952 10.0469 22.5869 10.1723 22.5663 10.3052Z",
    fill: "#12100B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5663 12.0914C22.5457 12.2262 22.4203 12.3179 22.2874 12.2973C22.1526 12.2767 22.0609 12.1513 22.0815 12.0184C22.1021 11.8836 22.2275 11.7919 22.3604 11.8125C22.4952 11.8312 22.5869 11.9566 22.5663 12.0914Z",
    fill: "#12100B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.68 11.1681C22.68 11.3029 22.5695 11.4133 22.4347 11.4133C22.2999 11.4133 22.1895 11.3029 22.1895 11.1681C22.1895 11.0333 22.2999 10.9229 22.4347 10.9229C22.5695 10.9229 22.68 11.0333 22.68 11.1681Z",
    fill: "#12100B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1692 9.67784C23.1692 9.81263 23.0587 9.92307 22.9239 9.92307C22.7892 9.92307 22.6787 9.81263 22.6787 9.67784C22.6787 9.54306 22.7892 9.43262 22.9239 9.43262C23.0587 9.43262 23.1692 9.54306 23.1692 9.67784Z",
    fill: "#12100B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1692 13.1241C23.1692 13.2589 23.0587 13.3694 22.9239 13.3694C22.7892 13.3694 22.6787 13.2589 22.6787 13.1241C22.6787 12.9894 22.7892 12.8789 22.9239 12.8789C23.0587 12.8789 23.1692 12.9894 23.1692 13.1241Z",
    fill: "#12100B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6118 10.4713C23.5912 10.606 23.4658 10.6978 23.3328 10.6772C23.1981 10.6566 23.1063 10.5312 23.1269 10.3983C23.1475 10.2635 23.2729 10.1717 23.4059 10.1923C23.5406 10.2129 23.6324 10.3384 23.6118 10.4713Z",
    fill: "#12100B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6118 12.2574C23.5912 12.3922 23.4658 12.4839 23.3328 12.4633C23.1981 12.4427 23.1063 12.3173 23.1269 12.1844C23.1475 12.0496 23.2729 11.9579 23.4059 11.9785C23.5406 11.9972 23.6324 12.1226 23.6118 12.2574Z",
    fill: "#12100B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7234 11.3341C23.7234 11.4689 23.6129 11.5793 23.4781 11.5793C23.3434 11.5793 23.2329 11.4689 23.2329 11.3341C23.2329 11.1993 23.3434 11.0889 23.4781 11.0889C23.6148 11.0889 23.7234 11.1993 23.7234 11.3341Z",
    fill: "#12100B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_29293",
    x1: 29.1005,
    y1: 35.6836,
    x2: 29.1005,
    y2: 26.9146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3394,
    stopColor: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#3D3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_29293",
    x1: 17.7731,
    y1: 20.9826,
    x2: 40.4259,
    y2: 20.9826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    stopColor: "#494848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6496,
    stopColor: "#323231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_29293",
    x1: 1.35203,
    y1: 11.6776,
    x2: 56.4387,
    y2: 11.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_29293",
    x1: 7.06029,
    y1: 16.9129,
    x2: 17.875,
    y2: 6.09819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    stopColor: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6728,
    stopColor: "#181817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebcam);
export default __webpack_public_path__ + "static/media/Webcam.cac4a5a7f26e920b55d6864484e062ac.svg";
export { ForwardRef as ReactComponent };